
export const loginUser = async (loginData) => {
    try {
      const response = await fetch('https://blog-swipe-backend.vercel.app/loginUser', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json', // Tell the server the content type is JSON
        },
        body: JSON.stringify(loginData), // Convert the object to a JSON string
      });
  
      console.log("Login data data:", loginData);
  
      if (!response.ok) {
        const error = await response.json();
        throw new Error(error.message || 'Failed to register');
      }
  
      const result = await response.json();
      console.log("Registration result:", result);
      return result;
    } catch (error) {
      console.log('Error registering user:', error);
      throw error;
    }
  };
  
  
  